import React, { Component } from "react";
import Swal from "sweetalert2";
import { TextareaAutosize } from "@material-ui/core";

class ModalAsignarEjecutado extends Component {
  render() {
    return (
      <>
        <div>
          <fieldset className="panel">
            <div className="container">
              <div className="row">
                <div className="form-group col-lg-7">
                  <label>
                    Meta: <span className="text-danger"> *</span>
                  </label>
                  <select
                    name="meta_id"
                    id="meta_id"
                    onChange={(e) => this.props.component.handleChangeEjecutado(e)}
                    value={this.props.state.asignar_ejecutado.meta_id}
                    className="form-control"
                    required
                  >
                    <option value="">Seleccione</option>
                    {this.props.state.metas_ejecutados.map((option) => (
                      <option key={option.id} value={option.id}>
                        {option.codigo} - {option.descripcion}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="form-group col-lg-3">
                  <label>
                    Ejecutado:<span className="text-danger"> *</span>
                  </label>
                  <input
                    name="ejecutado"
                    maxLength={15}
                    value={this.props.state.asignar_ejecutado.ejecutado}
                    onChange={(e) => this.props.component.handleChangeEjecutado(e)}
                    className="form-control"
                    placeholder="Ejecutados"
                    title="Ejecutados"
                  />
                </div>
                <div className={"col-md-2"}  style={{ marginTop: "1.5em" }}>
                  <button
                    type="button"
                    id="addEjecutado"
                    className="btn btn-info col-md-12 "
                    onClick={this.props.component.addEjecutado}
                  >
                    +
                  </button>
                </div>
              </div>
            </div>
            {/**tabla */}
            <hr></hr>
            <div className="table-responsive">
              <table className="table table-striped m-b-0 table-hover">
                <thead>
                  <tr>
                    <th className="text-center">Meta</th>
                    <th className="text-center">Ejecutado</th>
                    <th> </th>
                  </tr>
                </thead>
                <tbody>
                  {this.props.state.ejecutados.length !== 0 ? (
                    this.props.state.ejecutados.map((ejecutado, index) => (
                      <tr key={index} id={index}>
                        <td data-toggle="tooltip" data-placement="top">{ejecutado.codigo} - {ejecutado.meta}</td>
                        <td className="text-center" data-toggle="tooltip" data-placement="top">{ejecutado.ejecutado}</td>
                        <td className="text-center">
                          <button
                            className="btn btn-warning remover"
                            id={index}
                            data-id={ ejecutado.meta_id }
                            data-codigo={ejecutado.codigo}
                            data-descripcion={ejecutado.meta}
                            onClick={this.props.component.remmoveEjecutado}
                          >
                            <i
                              className="fas fa-trash"
                              id={index}
                              data-id={ ejecutado.meta_id }
                              data-codigo={ejecutado.codigo}
                              data-descripcion={ejecutado.meta}
                              onClick={this.props.component.remmoveEjecutado}
                            ></i>
                          </button>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td></td>
                      <td className="text-center">No hay ejecutados</td>
                      <td></td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </fieldset>
          <div className="btn-group float-right">
            <button
              type="button"
              onClick={() => {
                this.props.component.handleCloseModalE();
              }}
              className="btn btn-danger"
            >
              Regresar
            </button>
            <button
              type="submit"
              className="btn btn-success btn-block"
              onClick={(e) => {
                this.props.component.handleSubmit(e);
              }}
            >
              Guardar
            </button>
          </div>
        </div>
      </>
    );
  }
}

export default ModalAsignarEjecutado;
